import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from './Icon';

interface ToolCardProps {
  title: string;
  description: string;
  path: string;
  icon: string;
}

const ToolCard: React.FC<ToolCardProps> = ({ title, description, path, icon }) => {
  return (
    <Link 
      to={path} 
      className="tool-card block group"
    >
      <div className="flex items-start">
        <div className="p-3 bg-secondary/10 dark:bg-secondary/20 rounded-lg">
          <Icon name={icon} className="w-6 h-6 text-secondary" />
        </div>
        
        <div className="ml-4">
          <h3 className="text-lg font-medium group-hover:text-secondary dark:group-hover:text-secondary-light transition-colors">
            {title}
          </h3>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
            {description}
          </p>
        </div>
      </div>
      
      <div className="mt-3 flex items-center text-sm text-secondary dark:text-secondary-light">
        <span>Try it now</span>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform">
          <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
        </svg>
      </div>
    </Link>
  );
};

export default ToolCard;
